// @flow

import React from 'react';
import { colors } from '../constants';

const MaximizeIcon = ({ color }: { color: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      fill={color}
      fillRule="nonzero"
      d="M2 7h16a1 1 0 0 0 0-2H2a1 1 0 1 0 0 2z"
    />
  </svg>
);

MaximizeIcon.defaultProps = {
  color: colors.white,
};

export default MaximizeIcon;
